<template>
    <div class="news-wrapper" v-show="imgsArr" ref="newsBox">
        <div
            class="cloumn-list"
            v-for="(colIm, colIndex) in colCount"
            :ref="'col' + colIndex"
            :key="colIm"
        >
            <div
                class="model-list"
                v-for="(item, index) in renderList[colIndex]"
                :key="index"
                @click="openModel(item.id)"
            >
                <img :src="item.link" class="cover" alt="" />
                <div class="mask"></div>
                <div class="name" v-html="item.textarea"></div>
            </div>
        </div>

        <!-- <div ref="getMargin" class="get-margin"></div> -->
        <div class="mobile-model-list">
            <div
                class="item"
                v-for="(item, index) in imgsArr"
                @click="openModel(item.id)"
                :key="'mobile_' + index"
            >
                <div
                    :style="{ 'background-image': `url(${item.link})` }"
                    class="mobile-cover"
                ></div>
                <div class="mobile-mask"></div>
            </div>
        </div>

        <div v-if="noData" class="no-data">No more...</div>

        <el-dialog
            :title="null"
            :visible.sync="dialogVisible"
            width="100%"
            fullscreen
            :before-close="handleClose"
            destroy-on-close
        >
            <media-swiper
                :list="mediaList"
                pagination-type="fraction"
                urlKey="link"
                type="news"
            />
        </el-dialog>
    </div>
</template>

<script>
import MediaSwiper from '@/components/feature/MediaSwiper.vue';
import { Dialog } from 'element-ui';

export default {
    name: 'news',

    props: ['searchKey'],

    components: {
        MediaSwiper,
        ElDialog: Dialog,
    },

    data() {
        return {
            colCount: 4,
            imgsArr: [],
            over: false, // 是否到底
            rendering: false, // 渲染中
            lock: false,
            renderList: [[], [], [], []],
            colHeightArry: [],
            list: [],
            page: 1,

            id: this.$route.params.id,

            noData: false, // 数据已加载完

            // dialog
            mediaList: [],
            dialogVisible: false,
        };
    },

    mounted() {
        this.fetchList(1);

        window.onscroll = () => {
            // 瀑布流盒子
            const box = this.$refs.newsBox;
            const top = this.computedOffset(box, 'offsetTop');
            const height = box.offsetHeight;
            const clientHeight = document.documentElement.clientHeight;
            const scrollTop = document.documentElement.scrollTop;
            if (
                top + height < clientHeight + scrollTop + 50 &&
                !this.lock &&
                !this.rendering
            ) {
                this.lock = true;
                this.fetchList(this.page + 1);
            }
        };
    },

    watch: {
        $route() {
            this.$router.go(0);
        },
    },

    methods: {
        computedOffset(obj, prop) {
            if (obj === document.body || obj.offsetParent === document.body) {
                return parseInt(obj[prop], 10);
            }
            return (
                parseInt(obj[prop], 10) +
                this.computedOffset(obj.offsetParent, prop)
            );
        },
        fullData(index) {
            if (index < this.imgsArr.length) {
                const newImg = new Image();
                newImg.src = this.imgsArr[index].link;
                const loadTimer = setTimeout(() => {
                    newImg.onerror();
                }, 5000);
                newImg.onerror = function () {
                    newImg.src = ''; // 默认图片
                };
                newImg.onload = () => {
                    clearTimeout(loadTimer);
                    for (let i = 0; i < this.colCount; i++) {
                        this.colHeightArry[i] =
                            this.$refs['col' + i][0].offsetHeight;
                    }
                    // const min = this.colHeightArry.indexOf(Math.min(...this.colHeightArry));
                    const min = index % 4;
                    const tar = this.renderList[min]
                        ? this.renderList[min].concat(this.imgsArr[index])
                        : this.imgsArr[index];
                    this.$set(this.renderList, min, tar);
                    this.fullData(index + 1);
                };
            } else {
                this.rendering = false;
            }
        },
        updateWaterfall(eachItem) {
            if (!eachItem.length) return;
            const columns = 4;
            const arr = [];
            const marginItem = this.$refs.getMargin.clientWidth;
            for (let i = 0; i < eachItem.length; i++) {
                const imgWidth = eachItem[i].clientWidth;
                const imgHeight = eachItem[i].clientHeight;
                if (i < columns) {
                    eachItem[i].style.top = marginItem + 'px';
                    eachItem[i].style.left =
                        i === 0
                            ? imgWidth * i + 'px'
                            : imgWidth * i + marginItem * i + 'px';
                    arr.push(imgHeight + marginItem * 2);
                } else {
                    let minHeight = arr[0];
                    let index = 0;
                    for (let j = 0; j < arr.length; j++) {
                        if (minHeight > arr[j]) {
                            minHeight = arr[j];
                            index = j;
                        }
                    }
                    eachItem[i].style.top = arr[index] + 'px';
                    eachItem[i].style.left = eachItem[index].offsetLeft + 'px';
                    arr[index] = arr[index] + imgHeight + marginItem;
                }
            }
        },

        handleClose(done) {
            done();
        },

        // http
        fetchList(page) {
            if (this.noData) return;
            const limit = 20;

            this.$http
                .getNewsList({
                    limit,
                    page: page,
                    search: this.searchKey,
                })
                .then((res) => {
                    this.page = page;
                    if (res.count <= limit * this.page) this.noData = true;

                    const list = res.list.map((el) => {
                        el.textarea = el.textarea
                            .replace(/\n/g, '<br/>')
                            .replace(/ /g, ' &nbsp');
                        return el;
                    });
                    if (this.page === 1) this.imgsArr = [];
                    const len = this.imgsArr.length;
                    this.imgsArr = this.imgsArr.concat(list);
                    if (this.$store.state.cw >= 768) this.fullData(len);
                    this.lock = false;
                });
        },

        // detail
        async fetchDetail(id = '') {
            if (!id) return;

            const res = await this.$http.getNewsDetail({
                id,
            });
            return res;
        },

        // 点击详情
        async openModel(id) {
            const res = await this.fetchDetail(id);
            if (res && res.length) {
                this.mediaList = res;
                this.dialogVisible = true;
            } else {
                this.$message.warning('No details found.');
            }
        },
    },

    created() {
        if (this.$route.params.id) this.openModel(this.$route.params.id);
    },
};
</script>

<style lang="scss">
.news-wrapper {
    .el-dialog {
        background: transparent;
    }
    .el-dialog__header,
    .el-dialog__body {
        padding: 0;
    }
    .el-dialog__headerbtn {
        top: 0;
        right: 0;
        font-size: 60px;
        z-index: 99;
        @include media-mob {
            font-size: 30px;
        }
    }
    .el-dialog__close {
        font-family: "iconfont" !important;
        // font-size: 60px;
        color: #fddaba;
        // z-index: 4;
        &::before {
            content: "\e60a";
        }
    }
    .el-dialog__headerbtn:focus .el-dialog__close,
    .el-dialog__headerbtn:hover .el-dialog__close {
        color: #ffb36e;
    }
}
</style>

<style lang="scss" scoped>
.news-wrapper {
    display: flex;
    align-items: flex-start;
    padding: 0 0 60px;
    box-sizing: border-box;
    @include media-mob {
        padding: 0 20px 30px;
    }

    position: relative;
}
.cloumn-list {
    width: calc((100% - 42px) / 4);
    margin-right: 14px;
    &:last-child {
        margin-right: 0;
    }
    @include media-mob {
        display: none;
    }
}
.mobile-model-list {
    display: none;
    width: 100%;
    @include media-mob {
        display: flex;
        flex-wrap: wrap;
        padding: 0 0 30px;
    }
    .item {
        width: calc((100% - 10px) / 2);
        margin: 0 10px 10px 0;
        position: relative;
        &:nth-child(2n) {
            margin-right: 0;
        }
    }
    .mobile-cover {
        width: 100%;
        height: 240px;
        background-position: center;
        background-size: cover;
    }
    .mobile-mask {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.3);
    }
}
.model-list {
    width: 100%;
    margin: 14px 0 0 0;
    overflow: hidden;
    position: relative;
    cursor: pointer;
    &:hover {
        .mask,
        .name {
            opacity: 1;
        }
    }
    &:nth-child(4n) {
        margin-right: 0;
    }
    .cover {
        width: 100%;
        height: auto;
    }
    .mask {
        opacity: 0;
        transition: all 0.4s;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(186, 145, 83, 0.4);
    }
    .name {
        opacity: 0;
        transition: all 0.4s;
        text-align: left;
        position: absolute;
        z-index: 2;
        left: 0;
        right: 0;
        width: 100%;
        padding: 0 16px;
        box-sizing: border-box;
        font-size: 13px;
        font-family: Helvetica;
        color: #fff;
        line-height: 20px;
        bottom: 15px;
    }
}

.no-data {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 16px;
    font-size: 20px;
    color: #ddd;

    @include media-mob {
        bottom: 10px;
        font-size: 13px;
    }
}
</style>
